import React from 'react';
import PropTypes from 'prop-types';
import SelectInput from '../../form/select-input/SelectInput';

const propTypes = {
	// if select is the type of filter then provide list of filters to use
	filterTypeOptions: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			value: PropTypes.any.isRequired
		})).isRequired,

	// onChange callback (value) => do whatever you want
	onChange: PropTypes.func.isRequired,

	// the value to show
	// using "any" because it matches the ReactSelect component
	// eslint-disable-next-line react/forbid-prop-types
	value: PropTypes.any,

	// is multi select
	isMultiSelect: PropTypes.bool,
};

const defaultProps = {
	isMultiSelect: false,
	value: undefined,
};

export default class FilterDetailSelect extends React.Component {
	render() {
		return <SelectInput
				showLabel={false}
				label="Filter"
				field="filter"
				options={this.props.filterTypeOptions}
				value={this.props.value}
				multiSelect={this.props.isMultiSelect}
				onChange={(field, value) => this.props.onChange(field, value)}
				placeholder="Filter"
			/>;
	}
}

FilterDetailSelect.defaultProps = defaultProps;
FilterDetailSelect.propTypes = propTypes;